// extracted by mini-css-extract-plugin
module.exports = {"offer":"offer_offer__PJzB1","selectServiceBtn":"offer_selectServiceBtn__1l1Uk","selectServiceBtnActive":"offer_selectServiceBtnActive__2fGG3"};